import { Factory } from '@infodata-group/inf-commons';

export class DtoFactory<T> implements Factory<T> {
  constructor(public api: string) {}

  getApi(): string {
    return this.api;
  }
  build(o: T): T {
    return o;
  }
}
